export default "__VITE_ASSET__BcfUNljc__"